import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, LayoutGrid, Plus, Boxes, MoreHorizontal } from 'lucide-react';
import { cn } from '@easymoving/ui';
import { useWorkspace } from '../../context/WorkspaceContext';

/** Mobile bottom navigation (PRD §16.3). Center "Add" is the primary action. */
export function BottomNav() {
  const { t } = useTranslation();
  const { canEdit } = useWorkspace();

  const items = [
    { to: '/app', icon: Home, label: t('nav.dashboard'), end: true },
    { to: '/app/items', icon: LayoutGrid, label: t('nav.items'), end: false },
    { to: '/app/boxes', icon: Boxes, label: t('nav.boxes'), end: false },
    { to: '/app/more', icon: MoreHorizontal, label: t('nav.more'), end: false },
  ];

  return (
    <nav className="print:hidden md:hidden fixed bottom-0 inset-x-0 z-30 border-t hairline bg-bg/90 backdrop-blur-md pb-[env(safe-area-inset-bottom)]">
      <div className="mx-auto max-w-[640px] grid grid-cols-5 items-center h-16 px-2">
        {items.slice(0, 2).map((it) => (
          <NavItem key={it.to} {...it} />
        ))}
        <div className="flex justify-center">
          {canEdit && (
            <NavLink
              to="/app/items/new"
              aria-label={t('nav.add')}
              className="flex items-center justify-center size-13 -mt-6 rounded-full bg-petrol text-white shadow-pop hover:bg-petrol-deep transition-colors size-14"
            >
              <Plus className="size-7" />
            </NavLink>
          )}
        </div>
        {items.slice(2).map((it) => (
          <NavItem key={it.to} {...it} />
        ))}
      </div>
    </nav>
  );
}

function NavItem({
  to,
  icon: Icon,
  label,
  end,
}: {
  to: string;
  icon: typeof Home;
  label: string;
  end: boolean;
}) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          'flex flex-col items-center justify-center gap-0.5 text-[11px] font-medium h-full transition-colors',
          isActive ? 'text-petrol' : 'text-graphite-soft hover:text-graphite',
        )
      }
    >
      <Icon className="size-5" />
      {label}
    </NavLink>
  );
}
